import React from 'react';

import { TotalQuantity } from '@app/components/UI/Filters/TotalQuantity';

interface TableCounterProps {
	children?: number;
}

export const TableCounter: React.FC<TableCounterProps> = ({ children }: TableCounterProps) => (
	<TotalQuantity
		count={children}
		withTotalQuantity
	/>
);
